export default {
  'portal.embed.noUrlProvided': 'No template URL provided.',
  'portal.embed.notFound': 'Template not found.',
};
